module.exports = __webpack_public_path__ + "img/paper-plane-top-white.163b69c4.svg";